let bsParams = {
  year: "", // 年度
  publicationName: "", // 出版物名称
  isbn: "", // 专用书号 ISBN
  carrierForm: "", // 载体形式（选择项）
  publicationForm: "", // 出版形式（选择项）
  carrierFormQT: "", // 出版形式其他
  productionUnit: "", // 节目来源/制作单位
  programCapacity: "", // 节目时长或容量(分钟/兆)
  publicationQuantity: "", // 出版数量（张/盒）
  issueQuantity: "", // 发行数量（张/盒）
  unitPrice: "", // 发行单价（元）
  publishingTime: "", // 出版时间
  sampleDelivery: "", // 样品缴送（选择项）
  sign: "", // 书配盘标记（选择项）

  publishMaterialId: "", // publishMaterialId
  publishId: "", // 出版单位ID

  id: "", // id
};

let paramsRule = {
  year: [{ required: true, message: "请选择", trigger: "change" }], // 年度
  publicationName: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 180, message: "填写内容过长！", trigger: "blur" },
  ], // 出版物名称
  isbn: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 专用书号 ISBN
  carrierForm: [{ required: true, message: "请选择", trigger: "change" }], // 载体形式（选择项）
  publicationForm: [{ required: true, message: "请选择", trigger: "change" }], // 出版形式（选择项）
  carrierFormQT: [
    { required: true, message: "不能为空！", trigger: "blur" },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 专
  productionUnit: [
    // { required:true, message:'不能为空！', trigger:'blur' },
    { max: 127, message: "填写内容过长！", trigger: "blur" },
  ], // 节目来源/制作单位
  programCapacity: [{ required: false, message: "请输入", trigger: "change" }], // 节目时长或容量(分钟/兆)
  publicationQuantity: [{ required: true, message: "请输入", trigger: "change" }], // 出版数量（张/盒）
  issueQuantity: [{ required: true, message: "请输入", trigger: "change" }], // 发行数量（张/盒）
  unitPrice: [{ required: true, message: "请输入", trigger: "change" }], // 发行单价（元）
  publishingTime: [{ required: true, message: "请输入", trigger: "change" }], // 出版时间
  sampleDelivery: [{ required: true, message: "请选择", trigger: "change" }], // 样品缴送（选择项）
  sign: [{ required: true, message: "请选择", trigger: "change" }], // 书配盘标记（选择项）
};

export { bsParams, paramsRule };



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt9.js